import { useEffect, useState } from "react";

import { getOrderDetail } from "../aliyun-service-api";

export const useOrderDetail = (orderId) => {
  const [galleryDetail, setOrderDetail] = useState({});

  useEffect(() => {
    if (!orderId) {
      return;
    }
    getOrderDetail(orderId).then(setOrderDetail);
  }, [orderId]);

  return galleryDetail;
};



// WEBPACK FOOTER //
// ./src/containers/Video/hooks/use-order-detail.js